__turbopack_context__.v({
  "hasScroll": "styles-module__IsfBkW__hasScroll",
  "scrollContainer": "styles-module__IsfBkW__scrollContainer",
  "thumb": "styles-module__IsfBkW__thumb",
  "thumbDragging": "styles-module__IsfBkW__thumbDragging",
  "wrapper": "styles-module__IsfBkW__wrapper",
});
